import { render, staticRenderFns } from "./EmbedImmersiveLink.vue?vue&type=template&id=3a3053c9&scoped=true&"
import script from "./EmbedImmersiveLink.vue?vue&type=script&lang=js&"
export * from "./EmbedImmersiveLink.vue?vue&type=script&lang=js&"
import style0 from "./EmbedImmersiveLink.vue?vue&type=style&index=0&id=3a3053c9&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a3053c9",
  null
  
)

export default component.exports